export default {
  eyes: [
    {
      name: "conv2d2",
      modules: [
        {
          name: "Tiny curves",
          neurons: [182, 117, 171, 63, 146, 111, 130, 39, 180],
        },
      ],
    },
    {
      name: "mixed3a",
      modules: [
        {
          name: "Small circles / eyes",
          neurons: [168, 175, 174, 79, 125, 68],
        },
      ],
    },
    {
      name: "mixed3b",
      modules: [
        {
          name: "Small circles / eyes 2",
          neurons: [83, 370, 352, 363, 322, 82, 462],
        },
      ],
    },
  ],
  frequency: [
    {
      name: "conv2d1",
      modules: [
        {
          name: "High Frequency",
          neurons: [41, 30, 55, 11, 24, 51, 16, 44, 6, 8, 62, 7],
        },
        {
          name: "Low Frequency",
          neurons: [33, 46, 36, 1, 49, 48, 35, 2, 31, 60, 56, 25],
        },
      ],
    },
    {
      name: "conv2d2",
      modules: [
        {
          name: "High Frequency",
          neurons: [119, 123, 102, 173, 59, 162, 90, 164, 75, 159, 112, 189],
        },
        {
          name: "Low Frequency",
          neurons: [163, 98, 158, 188, 104, 52, 89, 67, 142, 5, 170, 128],
        },
      ],
    },
    {
      name: "mixed3a",
      modules: [
        {
          name: "High-Low Frequency",
          neurons: [
            186,
            110,
            86,
            117,
            180,
            136,
            153,
            112,
            70,
            108,
            132,
            106,
            113,
            88,
            160,
          ],
        },
      ],
    },
  ],
  triangles: [
    {
      name: "mixed3a",
      modules: [
        {
          name: "Triangles",
          neurons: [188, 94, 164],
        },
        {
          name: "Square",
          neurons: [107],
        },
      ],
    },
    {
      name: "mixed3b",
      modules: [
        {
          name: "Shapes",
          neurons: [327, 337, 347],
        },
        {
          name: "Object Boundaries",
          neurons: [251, 261, 257],
        },
      ],
    },
    {
      name: "mixed4a",
      modules: [
        {
          name: "Shapes",
          neurons: [436, 266],
        },
        {
          name: "Object Boundaries",
          neurons: [329, 282, 371],
        },
      ],
    },
  ],
  floppy: [
    {
      name: "mixed4a",
      modules: [
        {
          name: "ear shape",
          neurons: [168, 266],
        },
        {
          name: "ear texture",
          neurons: [153, 48],
        },
      ],
    },
    {
      name: "mixed4b",
      modules: [
        {
          name: "ear shape",
          neurons: [357, 377],
        },
        {
          name: "ear texture",
          neurons: [147],
        },
      ],
    },
    {
      name: "mixed4c",
      modules: [
        {
          name: "floppy ear",
          neurons: [15],
        },
      ],
    },
    {
      name: "mixed4d",
      modules: [
        {
          name: "floppy ear on dog",
          neurons: [426, 436],
        },
      ],
    },
  ],
  humans: [
    {
      name: "mixed4a",
      modules: [
        {
          name: "fluffies",
          neurons: [504, 470, 170, 81],
        },
        {
          name: "human",
          neurons: [391],
        },
        {
          name: "animals",
          neurons: [234, 325, 222, 308, 201, 274, 268],
        },
      ],
    },
    {
      name: "mixed4b",
      modules: [
        {
          name: "Human Faces",
          neurons: [493, 44, 475],
        },
        {
          name: "Hair",
          neurons: [168, 300, 168],
        },
        {
          name: "Animal Faces",
          neurons: [214, 418, 443, 429],
        },
      ],
    },
    {
      name: "mixed4c",
      modules: [
        {
          name: "Faces",
          neurons: [270, 333, 234, 225, 264, 304, 139, 112],
        },
        {
          name: "Hair",
          neurons: [382, 273],
        },
      ],
    },
  ],
  water: [
    {
      name: "mixed4a",
      modules: [
        {
          name: "Water units",
          neurons: [157, 447, 288, 340, 116, 279, 72, 167, 206],
        },
      ],
    },
    {
      name: "mixed4b",
      modules: [
        {
          name: "superposition?",
          neurons: [290, 140, 501, 108, 158, 192, 136, 297, 481],
        },
      ],
    },
    {
      name: "mixed4c",
      modules: [
        {
          name: "Superposition?",
          neurons: [6, 97, 276, 149, 349, 258, 138, 221, 164],
        },
      ],
    },
    {
      name: "mixed4d",
      modules: [
        {
          name: "Water again",
          neurons: [507],
        },
      ],
    },
  ],
}
